export default __webpack_public_path__ + "static/media/06.b37d8536.png";